module.exports = __webpack_public_path__ + "fonts/ProximaNovaACond-Thin.0f598dc396fa46e841a394c0b4ee79e2.ttf";